import { render, staticRenderFns } from "./AppCarousel.vue?vue&type=template&id=64441cce&"
import script from "./AppCarousel.vue?vue&type=script&lang=js&"
export * from "./AppCarousel.vue?vue&type=script&lang=js&"
import style0 from "./AppCarousel.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports